import { KeyboardEvent } from 'react';

export const onEnter = (e: KeyboardEvent, callBack: () => void) => {
    if (e.key === 'Enter' && !e.shiftKey) {
        callBack();
    }
};
